var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((4),function(number){return _c('v-col',{key:'loader-' + number,attrs:{"md":"6"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"card","height":"150"}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }